import MDMasterlist from '../pages/MDMasterlist';

const MdMastelistRoute = {
  public: [],
  auth: [
    {
      name: 'md_masterlist',
      path: '/md-universe/md-masterlist',
      permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM'],
      component: MDMasterlist,
    },
  ],
};

export default MdMastelistRoute;
